export { LOANS_BORROWERS_ACTION_TYPE, getLoansBorrowersAction } from './loanBorrowers.actions';
